<template>
  <div v-if="siteKey" ref="container" class="turnstile_box"></div>
</template>

<script>
// Cloudflare Turnstile（ボット対策）のウィジェット
// VUE_APP_TURNSTILE_SITE_KEY が設定されているときだけ表示される。
// 検証に成功すると "verified"（トークン）、期限切れ・エラー時は "expired" を emit する。
import { ref, onMounted, onBeforeUnmount } from 'vue';

const SCRIPT_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
let scriptPromise = null;

function loadScript() {
  if (window.turnstile) return Promise.resolve();
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = SCRIPT_SRC;
      s.async = true;
      s.onload = () => resolve();
      s.onerror = () => { scriptPromise = null; reject(new Error('Turnstile script load failed')); };
      document.head.appendChild(s);
    });
  }
  return scriptPromise;
}

export default {
  name: 'TurnstileWidget',
  emits: ['verified', 'expired'],
  setup(props, { emit, expose }) {
    const siteKey = process.env.VUE_APP_TURNSTILE_SITE_KEY || '';
    const container = ref(null);
    let widgetId = null;

    onMounted(async () => {
      if (!siteKey) return;
      try {
        await loadScript();
        widgetId = window.turnstile.render(container.value, {
          sitekey: siteKey,
          language: 'ja',
          callback: (token) => emit('verified', token),
          'expired-callback': () => emit('expired'),
          'error-callback': () => emit('expired'),
        });
      } catch (e) {
        console.error(e);
      }
    });

    onBeforeUnmount(() => {
      if (widgetId !== null && window.turnstile) window.turnstile.remove(widgetId);
    });

    const reset = () => {
      if (widgetId !== null && window.turnstile) window.turnstile.reset(widgetId);
      emit('expired');
    };

    expose({ reset });
    return { siteKey, container };
  },
};
</script>

<style scoped>
.turnstile_box { display: flex; justify-content: center; margin: 16px 0; min-height: 65px; }
</style>
